'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'ARRANGE_FIT',
	name: 'Arrange Fit',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: [],
	icon: 'fal fa-expand-arrows-alt',
	category: 'Layout',
	props: [],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};